import Scene from './Scene';
import Game from '../Game';
import RenderSystem from '../System/Render/RenderSystem';
import FarmSystem from '../System/Farm/FarmSystem';
import AnimationSystem from '../System/Animation/AnimationSystem';
import TimerSystem from '../System/Timer/TimerSystem';
import FarmUISystem from 'System/UI/FarmUISystem';
import AudioSystem from "System/Audio/AudioSystem";

export default class FarmScene extends Scene {
    public init(): void {
        this.addSystem(new TimerSystem(Game.store));
        this.addSystem(new FarmSystem(Game.store));
        this.addSystem(new FarmUISystem(Game.store));
        this.addSystem(new AnimationSystem(Game.store));
        this.addSystem(new RenderSystem(Game.store));
        this.addSystem(new AudioSystem(Game.store));

        this.systems.forEach(system => system.init());
    }
}
